/* [EZ] Exclusive brand — PDP behaviour when a product has custom.exclusive set (see
   ez-exclusive.liquid for the data + templates). Tags the featured media, hides quantity and the
   native buy buttons, swaps Add to Cart for "Purchase at <brand>" (link in a new tab, or disabled
   when custom.exclusive_link is empty), and shows "Sold only at <logo>" under the price.
   Re-applies after Horizon morphs the buy-buttons block on variant change. No core edits. */
(function () {
  var dataEl = document.querySelector('script[type="application/json"][data-ez-exclusive]');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!data || !data.brand) return;

  var tagTpl = document.querySelector('template[data-ez-exclusive-tag]');
  var soldTpl = document.querySelector('template[data-ez-exclusive-soldat]');

  function buyBlock() {
    return document.querySelector('[class*="buy-buttons-block"]:not(.sticky-add-to-cart *)');
  }

  function apply() {
    var info = document.querySelector('.product-information');
    if (!info) return;

    // NOTE: the sticky bar is NOT hidden here anymore — ez-pdp-sticky-variant.js renders it as a
    // "Purchase at <brand>" button (link, or disabled when no exclusive_link), matching this main button.

    // 1. EXCLUSIVE tag, upper-left of the featured media.
    var media = document.querySelector('.product-information__media slideshow-component') ||
                document.querySelector('.product-information__media');
    if (media && tagTpl && !media.querySelector('.ez-exclusive-tag')) {
      media.appendChild(tagTpl.content.cloneNode(true));
    }

    // 2. "Sold only at <logo>" directly under the price.
    var price = info.querySelector('product-price');
    if (price && soldTpl && !info.querySelector('.ez-exclusive-soldat')) {
      price.insertAdjacentElement('afterend', soldTpl.content.firstElementChild.cloneNode(true));
    }

    // 3. Buy area: hide quantity + native buy buttons, inject the Purchase-at button.
    var block = buyBlock();
    if (block && !block.querySelector('.ez-exclusive-buy')) {
      var qty = block.querySelector('.quantity-selector-wrapper, .quantity-selector');
      if (qty) qty.style.display = 'none';
      var atc = block.querySelector('.add-to-cart-button, button[name="add"]');
      block.querySelectorAll('.add-to-cart-button, button[name="add"], .shopify-payment-button, .additional-checkout-buttons')
        .forEach(function (el) { el.style.display = 'none'; });
      var bn = document.querySelector('.ez-buynow-block');
      if (bn) bn.style.display = 'none';

      var buy;
      if (data.hasLink && data.link) {
        buy = document.createElement('a');
        buy.href = data.link;
        buy.target = '_blank';
        buy.rel = 'noopener';
      } else {
        buy = document.createElement('button');
        buy.type = 'button';
        buy.disabled = true;
      }
      buy.className = 'ez-exclusive-buy' + (data.hasLink && data.link ? '' : ' is-disabled');
      buy.textContent = 'Purchase at ' + data.brand;
      if (atc && atc.parentNode) atc.parentNode.insertBefore(buy, atc);
      else block.appendChild(buy);
    }
  }

  var pending;
  function schedule() { clearTimeout(pending); pending = setTimeout(apply, 60); }

  function start() {
    apply();
    var info = document.querySelector('.product-information');
    // Horizon morphs the buy-buttons block (and media) on variant change — re-apply then.
    if (info) new MutationObserver(schedule).observe(info, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
